import { GenericLazyString } from '@eventbrite/i18n';
import interpolate from '@eventbrite/interpolate-lazy-string';
import classNames from 'classnames';
import React, { FunctionComponent } from 'react';
import { TicketStatus } from '../../../models/tickets';
import { TICKET_STATUS_MAP } from '../constants';
import './TicketSalesEndDate.scss';

export interface TicketSalesEndDateProps {
    formattedSalesEndDate: GenericLazyString | string;
    ticketStatus: TicketStatus;
    className?: Parameters<typeof classNames>[0];
    hideSaleDates: boolean;
}
const allowedStatuses = new Set([
    TicketStatus.onSale,
    TicketStatus.salesEndSoon,
]);

const TicketSalesEndDate: FunctionComponent<TicketSalesEndDateProps> = ({
    formattedSalesEndDate,
    ticketStatus,
    className,
    hideSaleDates,
}) => {
    if (!allowedStatuses.has(ticketStatus) || hideSaleDates) {
        return null;
    }

    return (
        <span
            className={classNames(
                'ticket-sales-end-date eds-text-color--ui-800',
                className,
            )}
            data-testid="ticket-sales-end-date"
        >
            {interpolate(
                TICKET_STATUS_MAP[ticketStatus].displayText,
                { date: formattedSalesEndDate },
                true,
            )}
        </span>
    );
};
export default TicketSalesEndDate;
